import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from 'classnames';
import styles from './video.module.scss';
const getSourceProps = (videoUrls)=>videoUrls.filter(Boolean).map((src)=>({
            key: src,
            src,
            type: `video/${src.split('.').pop()?.toLowerCase()}`
        }));
export const Video = ({ description, posterUrl, urls, ...videoProps })=>{
    const sourcesMobile = getSourceProps(urls.mobile);
    const sourcesDesktop = getSourceProps(urls.desktop ?? []).concat(sourcesMobile);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("video", {
                className: classNames(styles.video, styles.mobile),
                poster: posterUrl?.mobile,
                preload: "none",
                ...videoProps,
                children: [
                    sourcesMobile.map(({ key, src, type })=>/*#__PURE__*/ _jsx("source", {
                            src: src,
                            type: type
                        }, key)),
                    description
                ]
            }),
            /*#__PURE__*/ _jsxs("video", {
                className: classNames(styles.video, styles.desktop),
                poster: posterUrl?.desktop || posterUrl?.mobile,
                preload: "none",
                ...videoProps,
                children: [
                    sourcesDesktop.map(({ key, src, type })=>/*#__PURE__*/ _jsx("source", {
                            src: src,
                            type: type
                        }, key)),
                    description
                ]
            })
        ]
    });
};

//# sourceMappingURL=index.js.map